import React from "react";
import { observer } from "mobx-react";
import { EditionViewStore } from "../../store";
import { EditionViewForm } from "./EditionViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type EditionViewProps = {
  editionViewStore: EditionViewStore;
};

export const EditionView: React.FC<EditionViewProps> = observer(
  ({ editionViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <EditionViewForm
          editionViewStore={editionViewStore}
          documentationStateValue={editionViewStore.documentationStateValue}
          documentationLastOperationalError={
            editionViewStore.documentationLastOperationalErrorValue
          }
          publicationDate={editionViewStore.publicationDateValue}
          ejemplarPdfFiles={editionViewStore.ejemplarPdfFiles}
          name={editionViewStore.nameValue}
          editionTypeValue={editionViewStore.editionTypeValue}
          contentTypeOptions={editionViewStore.getContentTypeOptions()}
          contentType={editionViewStore.contentTypeValue}
          publicationLink={editionViewStore.publicationLinkValue}
          editionNumber={editionViewStore.editionNumberValue}
          price={editionViewStore.priceValue}
          worksValues={editionViewStore.worksValues}
          notes={editionViewStore.notesValue}
          dndaExpedienteNumber={editionViewStore.dndaExpedienteNumberValue}
          contractObservation={editionViewStore.contractObservationValue}
          documentationVisibleColumns={
            editionViewStore.documentationVisibleColumns
          }
          documentationSetColumnWiths={(x) =>
            editionViewStore.documentationSetColumnWiths(x)
          }
          documentationRows={editionViewStore.documentationRowsDyn}
          associatedDocumentsVisibleColumns={
            editionViewStore.associatedDocumentsVisibleColumns
          }
          associatedDocumentsSetColumnWiths={(x) =>
            editionViewStore.associatedDocumentsSetColumnWiths(x)
          }
          associatedDocumentsRows={editionViewStore.associatedDocumentsRowsDyn}
          userAttachmentsVisibleColumns={
            editionViewStore.userAttachmentsVisibleColumns
          }
          userAttachmentsSetColumnWiths={(x) =>
            editionViewStore.userAttachmentsSetColumnWiths(x)
          }
          userAttachmentsRows={editionViewStore.userAttachmentsRowsDyn}
          createdAt_={editionViewStore.createdAt_Value}
          lastUpdatedAt_={editionViewStore.lastUpdatedAt_Value}
          onPrint={(handlePrint: () => void) =>
            editionViewStore.printEdition(handlePrint)
          }
          onCancel={() => editionViewStore.cancelEdition()}
          onEdit={
            editionViewStore.isEditEnabled
              ? () => editionViewStore.editEdition()
              : undefined
          }
          ejemplarPdfViewAction={getViewAction(
            (props) => editionViewStore.fileDownload(props, "ejemplarPdf"),
            (props) => editionViewStore.viewFilePdf(props, "ejemplarPdf")
          )}
          viewFormWorks={(id: string) => editionViewStore.viewFormWorks(id)}
        />
        <ErrorDialog
          open={editionViewStore.errorDialogOpened}
          title={editionViewStore.errorTitle}
          description={editionViewStore.errorDescription}
          onClose={() => editionViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={editionViewStore.pdfViewerOpen}
          onClose={() => editionViewStore.closePdfViewer()}
          pdfUrl={editionViewStore.pdfViewerUrl}
          title={editionViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
